import { createNodeByType } from '../render/node';
import { SHAPES, TYPES } from '../render/constants';
import { createFontConfig } from '../render/text';
import { measureText } from '../render/utils/text';
import { getPaddingBox } from '../render/utils/node';
import { Action } from './action';
import { autoMoveInto } from './move';

function condition() {
  return true;
}

function createText(stageContext) {
  const { interactive } = stageContext.providers;
  interactive.cursor.setById('insert');
  const node = createNodeByType({
    type: TYPES.text,
  });
  interactive.insertNode = node;
}

export const insertText = new Action({
  name: 'Insert Text',
  handler: createText,
  shortcuts: '1',
  condition: condition,
});

function createImage(stageContext) {
  const { interactive } = stageContext.providers;
  interactive.cursor.setById('insert');
  const node = createNodeByType({
    type: TYPES.image,
  });
  interactive.insertNode = node;
}

export const insertImage = new Action({
  name: 'Insert Image',
  handler: createImage,
  shortcuts: '2',
  condition: condition,
});

function createShape(stageContext, shape) {
  const { interactive } = stageContext.providers;
  interactive.cursor.setById('insert');
  const node = createNodeByType({
    type: TYPES.shape,
    shape: shape,
  });
  interactive.insertNode = node;
}

export const insertRect = new Action({
  name: 'Insert Rectangle',
  handler: (ctx) => createShape(ctx, SHAPES.rect),
  shortcuts: 'R',
  condition: condition,
});

export const insertEllipse = new Action({
  name: 'Insert Ellipse',
  handler: (ctx) => createShape(ctx, SHAPES.ellipse),
  shortcuts: 'O',
  condition: condition,
});

export function getCenterPoint(renderContext) {
  const canvas = renderContext.context.canvas;
  const { scale: scaleProvider } = renderContext.providers;
  const canvasRect = canvas.getBoundingClientRect();
  const canvasX = (canvasRect.width - renderContext.paddingRight) / 2;
  const canvasY = canvasRect.height / 2;
  const dpr = renderContext.dpr;
  const point = {
    x: canvasX * dpr,
    y: canvasY * dpr,
  };
  return scaleProvider.offsetTransform(point);
}

export function addText(renderContext, options) {
  const frames = renderContext.api.getFrames();
  const frame = frames[0];
  const parentId = frame?.id;

  const textWidth = options?.w || 100;
  const textHeight = options?.h || 100;

  const center = getCenterPoint(renderContext);

  const newNode = {
    type: TYPES.text,
    text: 'New Text',
    fontSize: 48,
    fill: '#111',
    height: 'Hug',
    x: center.x - textWidth / 2,
    y: center.y - textHeight / 2,
    w: textWidth,
    h: textHeight,
    parentId,
    ...options,
  };
  const font = createFontConfig(newNode);
  const size = measureText(newNode.text, font, newNode.lineHeight || 1.35, 0);
  const padding = getPaddingBox(newNode);
  newNode.w = size.width + padding.x;
  newNode.h = size.height;
  newNode.x = center.x - size.width / 2;
  newNode.y = center.y - size.height / 2;

  const node = renderContext.api.addNode(newNode);
  autoMoveInto(renderContext, node);
  renderContext.api.selectNode(node.id);
  return node;
}

export function addShape(renderContext, payload) {
  const size = { w: payload.w || 240, h: payload.h || 240 };
  const center = getCenterPoint(renderContext);

  const node = renderContext.api.addNode({
    type: TYPES.shape,
    shape: SHAPES.rect,
    radius: 10,
    fill: '#fefefe',
    ...payload,
    x: center.x - size.w / 2,
    y: center.y - size.h / 2,
    w: size.w,
    h: size.h,
  });
  autoMoveInto(renderContext, node);

  renderContext.api.selectNode(node.id);
  return node;
}

export function addImage(renderContext, payload) {
  const textWidth = payload.w || 240;
  const textHeight = payload.h || 240;

  const center = getCenterPoint(renderContext);

  const node = renderContext.api.addNode({
    type: TYPES.image,
    ...payload,
    src: payload.src || '',
    x: center.x - textWidth / 2,
    y: center.y - textHeight / 2,
    w: textWidth,
    h: textHeight,
  });

  autoMoveInto(renderContext, node);

  renderContext.api.selectNode(node.id);
  return node;
}
